//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    props: ['contentText', 'hideMore'],
    computed: {
        ...mapState({
            video: ({ resourcesStore: {video} }) => video
        }),
    },
}
